var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 307 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.39 14.4c6.25 2.67 12.15 6 17.61 9.89a92.42 92.42 0 0190.05-9.9 94.35 94.35 0 0149.57 49.56 92.67 92.67 0 010 72.46 95.14 95.14 0 01-20 29.56 92.34 92.34 0 01-29.55 19.82 91.03 91.03 0 01-36.06 7.2 92.6 92.6 0 01-54-16.96 92.41 92.41 0 01-17.62 9.76 91.03 91.03 0 01-36.05 7.2 92.6 92.6 0 01-65.95-27.02 95.14 95.14 0 01-20.01-29.56 92.67 92.67 0 010-72.46A94.35 94.35 0 0163.95 14.4a92.42 92.42 0 0172.44 0zm-36.05 22.46v.07a62.56 62.56 0 00-24.5 4.86A58.68 58.68 0 0056.01 55.3a64.22 64.22 0 00-13.16 69.14 63.42 63.42 0 0013.16 20.02 59.63 59.63 0 0019.81 13.33 62.28 62.28 0 0024.51 4.86 60.9 60.9 0 0024.33-4.86 63.82 63.82 0 007.3-3.75 95.05 95.05 0 01-9.93-17.63 92.67 92.67 0 010-72.46 94.33 94.33 0 0110.36-18.24 61.28 61.28 0 00-32.06-8.85zm107.6 0l.07.07a62.56 62.56 0 00-32.37 8.83 92.47 92.47 0 01.37 108.3c2.4 1.42 4.9 2.66 7.49 3.73a62.28 62.28 0 0024.5 4.86c8.37.06 16.65-1.59 24.35-4.86a63.3 63.3 0 0033.16-82.37A64.48 64.48 0 00252.1 55.3a61.21 61.21 0 00-44.16-18.44zm-53.77 31.18l-.36.63a64.22 64.22 0 00.27 63.01 63.16 63.16 0 00.09-63.64z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    stroke: "#EACCF8",
    strokeWidth: 3,
    fillOpacity: 0,
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "assets/media/progress.aaa1c1c5.svg";
export { ForwardRef as ReactComponent };